<template>
  <div>
    <v-card class="nav-bar">
    <v-toolbar dense>
      <router-link to="/">
      <p class="mt-4 zoom"><v-icon>fas fa-arrow-left</v-icon> Gå tilbake</p>
      </router-link>
        

<v-spacer></v-spacer>
      <v-toolbar-title>
        Karriere og utdannelse
        </v-toolbar-title>

    </v-toolbar> 
  </v-card>
      <router-view />
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.nav-bar {
    margin-bottom:4vh;
}

</style>